import React from 'react'
import { SiteCreationWizard } from '../../../smart-components/index'

export default function () {
  return (
    <div>
      <SiteCreationWizard />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/site-manager/site-creation/index.js